import React, { FC } from "react";
import { Link } from "react-router-dom";
import { DesktopLogo } from "components/SVGIcons";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import animatedTruck from "../../assets/animated_truck.gif";

const NotFound: FC = () => {
  const { userToken } = useSelector((state: RootState) => state.authState);
  return (
    <div className="flex flex-row w-full min-h-screen items-stretch">
      <div className="basis-1/2 flex items-center justify-center bg-background mobile:hidden">
        <img src={animatedTruck} alt="Not Found" className="max-w-full h-auto rounded-lg" />
      </div>

      <div className="desktop:basis-1/2 flex flex-col items-center justify-center bg-background p-6">
        <DesktopLogo className="mb-1 w-auto mx-auto mobile:hidden" />
        <h1 className="text-9xl font-extrabold text-primary">404</h1>
        <p className="mt-4 text-2xl text-primary">Oops! Page not found.</p>
        <p className="mt-2 text-primary text-center">
          {`The page you're looking for doesn't exist or has been moved.`}
        </p>
        <Link
          to="/"
          className="border border-primary rounded-base text-primary bg-background mt-6 px-6 py-3 transition duration-300">
          {userToken ? "Go Home" : "Login"}
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
